module.exports = __webpack_public_path__ + "media/images/products/about/apr-687e0a155d280423995f6b15b05970cd.png";